import { Injectable, Injector } from '@angular/core';
import { CrudService } from './crud.service';
import { Language } from '../models/language';
import { DateAdapter } from '@angular/material';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import * as moment from 'moment';

@Injectable()
export class LanguagesService extends CrudService<Language> {
    languages: Language[] = [];

    constructor(injector: Injector,
        private _dateAdapter: DateAdapter<any>,
        private _dateTimeAdapter: DateTimeAdapter<any>,
        private _translate: TranslateService) {

        super('languages', injector, Language);

        this.readAll().subscribe(res => this.languages = res);
    }

    changeLanguage(lang: string): Observable<any> {
        this._dateAdapter.setLocale(lang);
        this._dateTimeAdapter.setLocale(lang);
        //moment.locale(lang);
        
        return this._translate.use(lang);
    }
}
